export const maintenancePriorityDeviationApplication = {
  headerTitle: {
    nb: 'Prioritetsvikelse',
    nn: 'Prioritetsviking',
    en: 'Priority deviation',
  },
  // Intro Page
  descriptionTitle: {
    nb: 'Om søknaden',
    nn: 'Om søknaden',
    en: 'About the application',
  },
  descriptionPart1: {
    nb: 'Søknaden benyttes dersom det er tatt opp nytt lån som skal sikres med pant i et formuesgode og ny kreditor krever at nytt lån skal ha bedre prioritet enn Innovasjon Norges obligasjoner. Ved innvilgelse av søknaden vil prioritetsrekken endres.',
    nn: 'Søknaden blir nytta dersom det er teke opp nytt lån som skal sikrast med pant i eit formuesgode og ny kreditor krev at nytt lån skal ha betre prioritet enn Innovasjon Noreg sine obligasjonar. Ved innvilging av søknaden vil prioritetsrekkja endrast.',
    en: 'The application is used when a new loan has been taken out that is to be secured by a pledge in an asset and the new creditor requires that the new loan have a higher priority than Innovation Norway\u{2019}s bonds. If the application is approved, the order of priority will be changed.',
  },
  descriptionPart2: {
    nb: 'Forsinkelsesrenter vil bli beregnet. Ved behandling av søknaden fra virksomheten har Innovasjon Norge anledning til å innhente kredittopplysninger.',
    nn: 'Forsinkingsrenter vil bli rekna ut. Ved behandling av søknaden frå verksemda har Innovasjon Noreg høve til å hente inn kredittopplysningar.',
    en: 'Late payment interest will be calculated. When processing the application from the business, Innovation Norway has the right to obtain credit information.',
  },
  changeFeeTitle: {
    nb: 'Endringsgebyr',
    nn: 'Endringsgebyr',
    en: 'Change fee',
  },
  changeFeeDescription: {
    nb: 'Behandling av en endringssøknad medfører en kostnad fra 1250,- NOK per konto. I de tilfeller kostnaden blir høyere enn 1250,- NOK vil du bli kontaktet av Innovasjon Norge med informasjon om størrelse på gebyr. Du vil da måtte godkjenne dette gebyret før vi behandler saken. Gebyr vil fremkomme i vedtaksbrevet, og effektueres ved neste faktura.',
    nn: 'Behandling av ein endringssøknad medfører ein kostnad frå 1250,- NOK per konto. Dersom kostnaden blir høgare enn 1250,- NOK, vil du bli kontakta av Innovasjon Noreg med informasjon om storleiken på gebyret. Du må då godkjenne dette gebyret før vi behandlar saka. Gebyret vil stå i vedtaksbrevet og bli fakturert ved neste faktura.',
    en: 'Processing a change application incurs a fee starting from NOK 1250 per account. If the fee exceeds NOK 1250, you will be contacted by Innovation Norway with information about the fee amount. You must then approve the fee before we process the case. The fee will be stated in the decision letter and applied to the next invoice.',
  },
  customerDetails: {
    nb: 'Kundedetaljer',
    nn: 'Kundedetaljar',
    en: 'Customer details',
  },
  customer: {
    nb: 'Kunde',
    nn: 'Kunde',
    en: 'Customer',
  },
  organizationNumber: {
    nb: 'Organisasjonsnummer',
    nn: 'Organisasjonsnummer',
    en: 'Organization Number',
  },
  downloadAndFillOutTheApplicationFormTitle: {
    nb: 'Last ned og fyll ut søknadsskjema',
    nn: 'Last ned og fyll ut søknadsskjemaet',
    en: 'Download and complete the application form',
  },
  downloadAndFillOutTheApplicationFormDescription: {
    nb: 'Fyll ut søknadsskjemaet før du laster det opp igjen på neste steg.',
    nn: 'Fyll ut søknadsskjemaet før du lastar det opp igjen i neste steg.',
    en: 'Fill out the application form before uploading it in the next step.',
  },
  signatureRightsTitle: {
    nb: 'Signaturrett',
    nn: 'Signaturrett',
    en: 'Signing authority',
  },
  signatureRightsDescription: {
    nb: 'Oppgi e-postadressen til alle personene som har signaturrett for virksomheten. Du kan søke opp virksomheten hos {0} for å se hvem som har signaturrett.',
    nn: 'Oppgi e-postadressa til alle personene som har signaturrett for verksemda. Du kan søkje opp verksemda hos {0} for å sjå kven som har signaturrett.',
    en: 'Provide the email address of all the people who have signing authority for the organization. You can look up the organization in the {0} to see who has signing authority.',
  },
  signatureRightsLink: {
    nb: 'Brønnøysundregistrene',
    nn: 'Brønnøysundregistera',
    en: 'Brønnøysund Register Centre',
  },
  authorizedSignatoryLabel: {
    nb: 'E-postadresse til signaturberettiget',
    nn: 'E-postadresse til signaturberettiga',
    en: 'Email address of authorized signatory',
  },
  addPartnerButton: {
    nb: 'Legg til e-postadresse',
    nn: 'Legg til e-postadresse',
    en: 'Add email address',
  },
  authorizedSignatoryLabelError: {
    nb: 'Du må oppgi en e-postadresse',
    nn: 'Du må oppgi ei e-postadresse',
    en: 'You must provide an email address',
  },
  emailSetErrorMessage: {
    nb: 'Du må oppgi en e-postadresse',
    nn: 'Du må oppgi ei e-postadresse',
    en: 'You must provide an email address',
  },
  emailValidFormatErrorMessage: {
    nb: 'Du må oppgi en e-postadresse med gyldig format',
    nn: 'Du må oppgi ei e-postadresse med gyldig format',
    en: 'You must provide an email address in a valid format',
  },
  delete: {
    nb: 'Slett',
    nn: 'Slett',
    en: 'Delete',
  },
  // Attachments Page
  titleAttachmentPage: {
    nb: 'Vedlegg',
    nn: 'Vedlegg',
    en: 'Attachments',
  },
  summaryAttachmentPage: {
    nb: 'Du kan laste opp følgende filtyper: .pdf, .docx, .xlsx, .odt og .ods',
    nn: 'Du kan laste opp følgjande filtypar: .pdf, .docx, .xlsx, .odt og .ods',
    en: 'You can upload the following file types: .pdf, .docx, .xlsx, .odt, and .ods',
  },
  applicationForm: {
    nb: 'Last opp utfylt søknadsskjema',
    nn: 'Last opp utfylt søknadsskjema',
    en: 'Upload completed application form',
  },
  applicationFormHelpText: {
    nb: 'Fyll ut og last opp søknadsskjemaet du lastet ned på forrige steg.',
    nn: 'Fyll ut og last opp søknadsskjemaet du lasta ned i førre steg.',
    en: 'Fill out and upload the application form you downloaded in the previous step.',
  },
  taxReturnForm: {
    nb: 'Næringsoppgave/skattemelding (landbruk) eller årsregnskap',
    nn: 'Næringsoppgåve/skattemelding (landbruk) eller årsrekneskap',
    en: 'Tax return (agriculture) or annual accounts',
  },
  interimAccountForm: {
    nb: 'Perioderegnskap',
    nn: 'Perioderekneskap',
    en: 'Interim financial statement',
  },
  interimAccountFormHelpText: {
    nb: 'Legg ved foreløpig resultat og balanse for inneværende år',
    nn: 'Legg ved førebels resultat og balanse for inneverande år',
    en: 'Attach preliminary profit and balance sheet for the current year',
  },
  budgetForm: {
    nb: 'Budsjett',
    nn: 'Budsjett',
    en: 'Budget',
  },
  valuationForm: {
    nb: 'Verdivurdering/takst (fast eiendom/fartøy)',
    nn: 'Verdivurdering/takst (fast eigedom/fartøy)',
    en: 'Valuation/appraisal (real estate/vessel)',
  },
  otherInformation: {
    nb: 'Andre opplysninger',
    nn: 'Andre opplysningar',
    en: 'Other information',
  },
  noInfoGiven: {
    nb: 'Ingen opplysninger gitt.',
    nn: 'Ingen opplysningar gitt.',
    en: 'No information given.',
  },
  // Summary Page
  summaryTitle: {
    nb: 'Oppsummering og innsending',
    nn: 'Oppsummering og innsending',
    en: 'Summary and submission',
  },
  termsAndConditionsTitle: {
    nb: 'Betingelser og vilkår',
    nn: 'Betingingar og vilkår',
    en: 'Terms and conditions',
  },
  termsAndConditionsDescriptionPart1: {
    nb: 'Ved behandling av søknaden kan Innovasjon Norge hente inn informasjon fra banken din om ditt kundeforhold der.',
    nn: 'Ved behandling av søknaden kan Innovasjon Noreg hente inn informasjon frå banken din om ditt kundeforhold der.',
    en: 'When processing the application, Innovation Norway may obtain information from your bank about your customer relationship there.',
  },
  termsAndConditionsDescriptionPart2: {
    nb: 'Forsinkelsesrenter vil bli beregnet. Ved behandling av søknaden fra virksomheten har Innovasjon Norge anledning til å innhente kredittopplysninger.',
    nn: 'Forsinkingsrenter vil bli rekna ut. Ved behandling av søknaden frå verksemda har Innovasjon Noreg høve til å hente inn kredittopplysningar.',
    en: 'Late payment interest will be calculated. When processing the application from the business, Innovation Norway may obtain credit information.',
  },
  termsAndConditionsDescriptionPart3: {
    nb: 'Behandling av en endringssøknad medfører en kostnad fra 1250,- NOK per konto. I de tilfeller kostnaden blir høyere enn 1250,- NOK vil du bli kontaktet av Innovasjon Norge med informasjon om størrelse på gebyr.',
    nn: 'Behandling av ein endringssøknad medfører ein kostnad frå 1250,- NOK per konto. Dersom kostnaden blir høgare enn 1250,- NOK, vil du bli kontakta av Innovasjon Noreg med informasjon om storleiken på gebyret.',
    en: 'Processing a change application involves a fee starting from NOK 1250 per account. If the fee exceeds NOK 1250, you will be contacted by Innovation Norway with information about the amount.',
  },
  confirmSectionTitle: {
    nb: 'Bekreft før innsending',
    nn: 'Stadfest før innsending',
    en: 'Confirm before submission',
  },
  confirmCheckbox1: {
    nb: 'Jeg bekrefter at disse opplysningene stemmer',
    nn: 'Eg stadfestar at desse opplysningane er riktige',
    en: 'I confirm that this information is correct',
  },
  confirmCheckbox2: {
    nb: 'Jeg bekrefter at jeg har lest og er kjent med Innovasjon Norges betingelser og vilkår for denne søknaden',
    nn: 'Eg stadfestar at eg har lese og er kjent med Innovasjon Noreg sine vilkår og betingingar for denne søknaden',
    en: 'I confirm that I have read and am familiar with Innovation Norway’s terms and conditions for this application',
  },
  optionalLabel: {
    nb: 'Valgfritt',
    nn: 'Valfritt',
    en: 'Optional',
  },
} as const;
